const axios = require('axios');

/**
 * Gets the average mortgage rate on a 30 year fixed mortgage in the US
 * Leverages the quandl api to get this data
 * @return {object} - date of quote + the quote itself / returns false on failure
 */
const getMortgageRate = async () => {
  const url = 'https://www.quandl.com/api/v3/datasets/WFC/RR_CON_30YFIXED_APR.json';
  try {
    const rsp = await axios.get(url);
    if (rsp.data.dataset) {
      if (Array.isArray(rsp.data.dataset.data) && rsp.data.dataset.data.length > 0) {
        const quote = rsp.data.dataset.data[0];
        return {
          date: quote[0],
          quote: setPrecision(quote[1]),
        };
      }
    }
  } catch (e) {
    return false;
  }

  return false;
};

/**
 * Fix number to 2 decimal points
 * @param {number/string} floatingNum - a number to fix
 * @return {string} - number fixed to 2 decimal points (0.00)
 */
const setPrecision = (floatingNum) => {
  if (typeof floatingNum !== 'number') {
    floatingNum = parseFloat(floatingNum);
  }
  return floatingNum.toFixed(2);
};

/**
 * Since we will make multiple API calls, bundle them all in one function then return the final result
 * @return {Promise} - When resolves, returns all data from API calls
 */
const getQuotes = async () => {
  const quotes = {};

  const mortgageRate = await getMortgageRate();

  if (mortgageRate) {
    quotes.mortgageRate = mortgageRate;
  }

  return quotes;
};

export {
  getQuotes,
};
